var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAstridClassicListen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 75 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 27,
    rx: 8,
    fill: "#001593"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    width: 27,
    height: 27,
    rx: 8,
    fill: "#001593"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.025 5.80755C57.2408 6.05297 54.375 9.37005 54.375 13.1621V18.4584C54.375 19.7726 55.4358 20.8334 56.75 20.8334H57.5417C58.4125 20.8334 59.125 20.1209 59.125 19.2501V16.0834C59.125 15.2126 58.4125 14.5001 57.5417 14.5001H55.9583V13.1463C55.9583 10.1063 58.3017 7.46214 61.3338 7.37505C64.4767 7.28797 67.0417 9.79755 67.0417 12.9167V14.5001H65.4583C64.5875 14.5001 63.875 15.2126 63.875 16.0834V19.2501C63.875 20.1209 64.5875 20.8334 65.4583 20.8334H66.25C67.5642 20.8334 68.625 19.7726 68.625 18.4584V12.9167C68.625 8.8238 65.1733 5.53839 61.025 5.80755Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3013 17.8125H34.8934V11.4944H32.3013V17.8125Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2432 17.8125H24.8353V9.7594H22.2432V17.8125Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.043 13.4844H26.0353V11.4949H21.043V13.4844Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9824 9.46411C34.9824 10.2228 34.3591 10.8379 33.5903 10.8379C32.8215 10.8379 32.1982 10.2228 32.1982 9.46411C32.1982 8.70544 32.8215 8.09034 33.5903 8.09034C34.3591 8.09034 34.9824 8.70544 34.9824 9.46411Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.8965 16.5509C46.8965 17.3096 46.2732 17.9247 45.5044 17.9247C44.7356 17.9247 44.1123 17.3096 44.1123 16.5509C44.1123 15.7922 44.7356 15.1771 45.5044 15.1771C46.2732 15.1771 46.8965 15.7922 46.8965 16.5509Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0767 13.256C18.0767 13.1499 18.1761 12.9913 18.517 12.9913C18.7184 12.9913 19.1353 13.0596 19.5306 13.201L19.5299 13.2003C19.5432 13.2052 19.5554 13.2099 19.5679 13.2145C19.6392 13.2411 19.7094 13.2698 19.7773 13.3011C19.9949 13.3996 20.1209 13.4901 20.2756 13.6026C20.2816 13.6068 20.287 13.6113 20.2922 13.6157V11.6137C19.923 11.6004 19.2412 11.3619 18.4176 11.3619C16.5571 11.3619 15.5061 12.1037 15.5061 13.4679C15.5061 15.4284 18.0198 15.5342 18.0198 16.0111C18.0198 16.1172 17.949 16.2494 17.6647 16.2494C17.3084 16.2494 16.6419 16.0703 16.0995 15.8225C15.7415 15.6774 15.5985 15.5839 15.4209 15.4599V17.6139C15.8045 17.6139 16.8838 17.9714 17.7641 17.9714C19.6957 17.9714 20.6189 17.0707 20.6189 15.8389C20.6189 13.8787 18.0767 13.7196 18.0767 13.256Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0703 17.8128H14.6625V11.4946H12.0703V17.8128Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8646 13.422C10.1754 13.422 9.61666 13.9734 9.61666 14.6537C9.61666 15.3341 10.1754 15.8857 10.8646 15.8857C11.554 15.8857 12.1128 15.3341 12.1128 14.6537C12.1128 13.9734 11.554 13.422 10.8646 13.422ZM13.1926 14.6537C13.1926 16.4602 11.8061 17.9248 10.0963 17.9248C8.38625 17.9248 7 16.4602 7 14.6537C7 12.8473 8.38625 11.383 10.0963 11.383C11.8061 11.383 13.1926 12.8473 13.1926 14.6537Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.6025 17.8128H43.1947V8.09027H40.6025V17.8128Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3973 13.422C38.7081 13.422 38.1492 13.9734 38.1492 14.6537C38.1492 15.3341 38.7081 15.8857 39.3973 15.8857C40.0865 15.8857 40.6453 15.3341 40.6453 14.6537C40.6453 13.9734 40.0865 13.422 39.3973 13.422ZM41.725 14.6537C41.725 16.4602 40.3388 17.9248 38.629 17.9248C36.919 17.9248 35.5327 16.4602 35.5327 14.6537C35.5327 12.8473 36.919 11.383 38.629 11.383C40.3388 11.383 41.725 12.8473 41.725 14.6537Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6039 13.6579C30.9567 13.6579 31.2967 13.8028 31.54 14.034V11.4402C31.54 11.4402 31.3693 11.3619 31.0287 11.3619C30.1054 11.3619 29.4472 11.8314 29.1484 12.6338V11.4944H26.7964V17.8125H29.3885V14.9506C29.3885 14.1658 29.9327 13.6579 30.6039 13.6579Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAstridClassicListen);
export default __webpack_public_path__ + "static/media/astrid_classic_listen.87174198084bd8300c92220bf8feb52d.svg";
export { ForwardRef as ReactComponent };